var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9500_45788",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 87,
    height: 87
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "url(#pattern0_9500_45788)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9500_45788)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "url(#pattern1_9500_45788)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "#029245"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_9500_45788",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9500_45788",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_9500_45788",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9500_45788",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9500_45788",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFSUlEQVR4nO2dTYgcRRiGK/6hePAfd6p6d0GDSm5iQAUPHkTxoAfxICiInhRRDwqCl1GnvslAEES9BBFB9CIeFEy8KAj+gXiRBPTibmbqm41iEHRRo5vsSCVs1lSXme6Z7vqqvu4HBjZhmH73faaru2uqZ4WYAiqYpPAwCjZQ9h8W3KEuGktJ0Zso9WOCM9QlYyslbSHIfU9xf1kRGdg0KakKQa5SUhNiFJzI/VvqRwUXUhOCsv9IXgqjPSU1IcL+H2cpKQphLSVVIWylpCyEpZTUhbCTwkEIKylchLCRwkkICynchCQvhaOQpKVwFZKsFM5CkpTCXUhyUpogJCkpTRGSjJQmCUlCStOERC+liUKiltJUIdFKabKQKKWkJgQDPU6tZiFYS9wKgbNJ2WiFRLKHkI0Y5AGm0AppOEj9BiUPEBnkfZAHiAzyPsgDRAZ5H+QBIoO8D/IAkUHeB3mAyCDvgzxAZJD3QR4gMsj7IA8QGeR9kAeIDPI+yANEBnkf5AEig7wP8gCRQd4HeYDIIO+DPEBkkPdBHiAyyPsgDxAZ5H2QB4gM8j7IA0QGeR/kASKDvA/yAJFB3gd5gMgg74M8QGRU1ceRq/dejBI+Gnd6t5EE4AJW1AdK/cr2wm3Yt7rcvTRoAC5gBX0YpW/xrKjvBQvACZyzj0O7uheg1AfPlAGH7RAWJAA3cM4+UOqu+xoo9T3BAnAD5+gD5UvXo4S/HBlvBwvAEZyxj4nonmMUfO4MVb+sLcBVQQJwBWfsY5TBk/mhCh4IFoArOEMf485gySj9uzNU7Q8WgDM4Qx9G6Q+doeo3lL3FYAE4gyX7GGW9Bz1D1ePBAnAHS/SBsn+FUfCzcwH4lT3ABwnQBLCUEHjHOW4cW1uAXcECNAEs2IdR+m73uUbB88ECNAUs0IedBjEKVpy947tvb9p3fpAATcIovfqfd/yK7zko9avOceP4cFHvriRAK8QzFElA+7A/ew7kt3pmcveKqmiFlJ3JhUPOcWOl8ExuEVohxTEKXnD2jE2UvTtElbRCijHuwA32tNa5AHxDVE0rpOhMrv7COas6Mlzac5momlbIdIzST3muOe4TdZCiEKN6t4+y/s4Q2zo1kwvrzlD1fm0bTE3IcFHvtlPdRumfUO65se7toYQDzlD16+El3alvgwkJGWX9nSdFbA8b6+NO/866tmcUPJSfya35j1imJASlBk9Bx4yC+6ve1rjTvdJ+BOsMVZ9OxGSHqJOUhEzEZMfWAjTnAHtirs8gCszkGgV/DBd711a5jeSFbGGUfu7kRVn+g6GBqADfTC5KeEaEIEUhFvsVrvZbQz17y1sT0T1PzMj/zOR+MxHvnStCkKoQi12AhlL/6ZHywSh7+SIxA0bBa85rbYQ4m2MhxGJU/2aj9FHPwf6zH68ZXCLKv9bxmdbkVkXqQiz2Y1OjYOSRcnCUaSVmn8n9YXW5e6EICQchlrWF3rJR+vv88KVXUfavE1MwSr/onrmVvrejCrgIsYyy7uVGwZceKUftLQKixEyuUfp1QQEnIdt3Lun9ngP9+ijTd4liM7njssefyuAmxGJPe42CNz3XEn+7622Ngqfzz+vfK6jgKGT7qh4GnuFrc+sizz+Tq98VlOTeHYk9jIIV32KE07+f7D3ru6o3CjRK/fHctw9UDXWhWMVDAk6dtZX6n2mvY9fpCmqaIMRiFyPkbhk48zUOiBggL1PVO2Tl747NX9VbUfZ4Un/bLd5rDqP00Nk7nsg/syUYRg2y07cuS/h6rtsHWqrBfrOCUfqToDO5LeKs1P5xrId/AcEw38VtmooYAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFile);
export default __webpack_public_path__ + "static/media/check-file.304efa16930c1e4518d8d832a7c70d33.svg";
export { ForwardRef as ReactComponent };